"use client";

import ComedianPageNav from "../header/ComedianPageNav";

export enum ContentNavButtons {
  VIDEOS = "Videos",
  TOUR_DATES = "Tour Dates",
  BIO = "Bio",
  MERCH_STORE = "Merch Store",
  TIP_ME = "Tip Me",
  SHARE = "Share",
}

export default function ContentNav() {
  return (
    <div className="flex flex-row justify-center">
      <ComedianPageNav
        className="flex flex-row md:w-[30rem] rounded-md drop-shadow-none border-none bg-transparent"
        listClassName="flex flex-row"
        itemClassName="flex-row text-sm md:text-md gap-1 md:gap-1.5"
      />
    </div>
  );
}
